import { forwardRef } from "react";
import styles from "./Input.module.css";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	error?: string | undefined;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
	({ className, error, onClick, ...props }, ref) => {
		return (
			<input
				ref={ref}
				className={[styles.input, error && styles.error, className].filter(Boolean).join(" ")}
				onClick={(e) => {
					if (props.type === "date") e.currentTarget.showPicker?.();
					onClick?.(e);
				}}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";
